import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown'; // Import Markdown parser
import classNames from 'classnames';
import css from './TooltipWrapper.module.css';

const TooltipWrapper = ({ text, toolTipClassName }) => {
  const tooltipClasses = classNames(css.tooltip, toolTipClassName);
  return (
    <div className={css.tooltipWrapper}>
      <span className={css.infoIcon} tabIndex="0">
        &#9432;
        <span className={tooltipClasses}>
          <ReactMarkdown>{text}</ReactMarkdown> {/* Render Markdown content */}
        </span>
      </span>
    </div>
  );
};

TooltipWrapper.propTypes = {
  text: PropTypes.string.isRequired, // Tooltip text is required
};

export default TooltipWrapper;